enum InternalRoutes {
  PAGE_NOT_FOUND = '/account/page-not-found',
  LOGOUT = '/account/logout',
  PROFILE = '/account',
  CSV_GUIDELINES = '/account/csv-guidelines',
}

export default InternalRoutes;
